export const PF = 'add-edit-brand';
